import { FormattedMessage } from 'react-intl';
import ExperimentalLabel from 'src/components/ExperimentalLabel/ExperimentalLabel';

import './FactCheckScopeNotice.sass';

const FactCheckScopeNotice = ({ inline = false }: { inline?: boolean }) => {
	return (
		<div className={`fact-check-scope-notice ${inline ? 'inline' : ''}`} role="note">
			<ExperimentalLabel mini />
			<p>
				<FormattedMessage id="fact-check-scope-notice.text" />
			</p>
		</div>
	);
};

export default FactCheckScopeNotice;
